<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IhIjvq/tc-custom/9781497617544.jpg?1727649762660" alt="This image is the cover for the book Maze of Stars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Maze of Stars
      </h1>
      <p class="bookDescription body article font2">
        <b>A thought-provoking novel of a sentient spaceship’s voyages, from the Hugo Award–winning author of <i>Stand on Zanzibar</i>.</b><br/><br/> "One of the most important science fiction authors. Brunner held a mirror up to reflect our foibles because he wanted to save us from ourselves." —SF Site<br/><br/> Among six hundred thousand stars visited by man, sixty thousand have planets hospitable to life, six thousand have developed life and six hundred have been settled, or seeded, with humanity. A vast vessel, known simply as Ship, travels an endless route, checking in with all the settled planets, observing, offering help where it can as some flourish, some falter but all change and evolve. Unexpectedly, Ship has developed feelings and intelligence and it struggles with human-like emotions as it sees the many ways that man can evolve or devolve when left to his own devices with the one eternal constant--change. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Brunner
      </h2>
      
      <p class="authorDescription body article">John Brunner started his career as a productive writer of Ace Double Science Fiction novels, sometimes writing both sides of the same double. He produced a wide variety of entertaining and well-conceived science fiction adventures before testing his ambitions with more and more complex and stylistically sophisticated novels. Among his triumphs are&#160;<I>Stand on Zanzibar</I>&#160;(Hugo winner for Best Novel),&#160;<I>The Jagged Orbit</I>,&#160;<I>The Sheep Look Up</I>,&#160;<I>The Shockwave Rider</I>, and&#160;<I>A Maze of Stars</I>. Although he wrote relatively little fantasy, he was widely acclaimed for a series of short stories collected as&#160;<I>The Compleat Traveller in Black</I>. Brunner also wrote mysteries, thrillers, and several well-regarded historical novels.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3145b835